export default "__VITE_ASSET__CPj0RaCw__"